import { render, staticRenderFns } from "./SubmerchantList.vue?vue&type=template&id=08b93b9d&"
import script from "./SubmerchantList.vue?vue&type=script&lang=js&"
export * from "./SubmerchantList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports